import io from 'socket.io-client'
import { URI } from './config'

export const socket = io(URI, {
  transports: ['websocket'],
})
